<template>    
    <div class="container files">
        <div class="files__header">
            <div class="row d-flex">
                <div class="col-9 d-flex align-items-center">
                    <router-link :to="{name: 'Categories'}" class="files__header-back"><img src="../../../assets/img/back_arrow.png"></router-link>
                    <h1 class="float-none"> {{ category }}</h1>
                </div>
            </div>
        </div> 
        <div class="profile" v-if="files.length == 0">
            <p>Brak plików w tej kategorii</p>
        </div>
        <div class="row row-flex files__list" v-if="files.length > 0">
            <div class="col-12 col-md-6 col-lg-9">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-3 files__list-col" v-for="file in files" :key="file.id">
                        <div class="files__list-item" :class="{ 'files__list-item--active': (fileSelected && file.id == fileSelected.id) }" @click="selectFile(file)">
                            <div class="files__list-item-desc">
                                <p>#{{ file.id }}</p>
                                <p><a href="" @click.prevent.stop="download(file.id, file.name, file.extension)">{{ file.name }}</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
                <div class="files__catalog-desc" v-if="fileSelected">
                    <div class="files__catalog-desc-header">
                        {{ fileSelected.name }}
                    </div>
                    <div class="files__catalog-desc-footer">
                        <p class="files__catalog-desc-label">Opis:</p>
                        <p class="files__catalog-desc-value">{{ fileSelected.description }}</p>
                        <table class="files__catalog-desc-table">
                            <tbody>
                                <tr>
                                    <th class="files__catalog-desc-label">ID:</th>
                                    <td class="files__catalog-desc-value">{{ fileSelected.id }}</td>
                                </tr>
                                <tr>
                                    <th class="files__catalog-desc-label">Link:</th>
                                    <td class="files__catalog-desc-value"><a href="" @click.prevent="download(fileSelected.id, fileSelected.name, fileSelected.extension)">Pobierz</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'
import { store } from '@/app/store'

export default {
  name: 'FilesComponent',
  data () {
    return {
      files: [],
      fileSelected: null
    }
  },
  beforeRouteEnter(to, from, next) {
    Vue.axios.all([
      Vue.axios({
        method: 'get',
        url: '/downloadables',
        params: {
            categories: [to.params.id]
        }
      }),
      Vue.axios({
        method: 'get',
        url: '/downloadables/categories'
      })
    ])
    .then(Vue.axios.spread((filesResponse, categoriesReponse) => {
      next(vm => {
          store.dispatch('setFileCats', categoriesReponse.data.data)
          vm.files = filesResponse.data.data.downloadables
      })
    }))
    .catch(error => next(false))
  },
  mounted () {
      
  },
  methods: {
      download: function(file_id, file_name, file_ext) {
          var _this = this
          Vue.axios({
            method: 'get',
            url: '/downloadables/' + file_id,
            params: {
            },
            responseType: 'blob'
        })
        .then(response => {
            var headers = response.headers;
            var blob = new Blob([response.data],{type:headers['content-type']});
            var FileSaver = require('file-saver');
            FileSaver.saveAs(blob, file_name + "." + file_ext);
            // var link = document.createElement('a');
            // document.body.appendChild(link);
            // link.href = window.URL.createObjectURL(blob);
            // console.log(file_ext);
            // link.download = file_name + "." + file_ext;
            // link.click();
            // document.body.removeChild(link);
        })
        .catch(error => {
            console.log(error)
        })
      },
      selectFile: function(file) {
            if( this.fileSelected && this.fileSelected.id == file.id )
                this.fileSelected = null
            else    
                this.fileSelected = file
      }
  },
  computed: {
    category() {
        let _this = this
        let result = this.$store.state.file_cats.filter(function(c) {
            return c.id == _this.$route.params.id
        });

        if( result[0] )
            return result[0].name
            
        return null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/files/FilesComponent.vue